<mat-form-field [ngClass]="field.fieldSize? 'col-md-' + field.fieldSize  : field.label.length > 100 ?
  'col-md-12': field.label.length > 50 ?
  'col-md-6' :  field.label.length > 30 ?
  'col-md-4' :'col-md-3'" [formGroup]="group" appearance="fill" [matTooltip]="field.hint"
  [matTooltipDisabled]="!field.hint" matTooltipPosition="above" matTooltipClass="sbm-tooltip">

  <mat-label>
    <app-required *ngIf="isRequired()"></app-required>
    <ng-container *ngIf="field.sequence>=0 && !field.hideSequence"> {{field.sequence + 1}}) </ng-container>
    {{field.label}}
  </mat-label>

  <span matPrefix *ngIf="field.inputType==='amount'">₹ &nbsp;</span>
  <ng-container *ngIf="field.inputType==='amount'||field.inputType==='decimal';else default">
    <input matInput [formControlName]="field.name" [type]="isNativeType(field.inputType) ? field.inputType: 'text'"
      restrictDecimal [toDecimalPlaces]="field.inputType==='amount'?2:3"
      [attr.maxlength]="field.inputLength ? field.inputLength : ''" [placeholder]="field.placeholder">
  </ng-container>

  <ng-template #default>
    <input matInput [formControlName]="field.name" [type]="isNativeType(field.inputType) ? field.inputType: 'text'"
      restrictTo [valType]="isNativeType(field.inputType) ? null : field.inputType"
      [attr.maxlength]="field.inputLength ? field.inputLength : ''" [placeholder]="field.placeholder">
  </ng-template>

  <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
    <mat-error *ngIf="group.get(field.name).hasError(validation.name)">
      {{validation.message ? validation.message : getValidationMessage(validation.name)}}
    </mat-error>
  </ng-container>
  <mat-hint *ngIf="field.inputType==='amount'">Please enter amount only (Eg. 10.00) </mat-hint>
</mat-form-field>
